import React from 'react';

export default function useSaveEditor(editorController) {
	const [isLoading, setIsLoading] = React.useState(false);

	const handleSave = async () => {
		setIsLoading(true);
		await editorController.save();
		setIsLoading(false);
	};

	return {
		isLoading,
		handleSave,
	};
}
